import { TipoBico } from './../../../classes/TipoBico';
import { TipoBicoService } from './../../../services/tipo-bico.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TipoAplicacao } from 'src/app/classes/TipoAplicacao';
import { TipoAplicacaoService } from 'src/app/services/tipo-aplicacao.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from 'src/app/services/storage.service';
import Swal from 'sweetalert2';
import { CustomToastyService } from 'src/app/theme/shared/components/toasty/custom-toasty.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { ColumnModel, ForeignKeyService, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { SyncGridComponent } from '../../shared-farm/sync-grid/sync-grid.component';
import { finalize } from 'rxjs/operators';
import { FormsTipoAplicacaoComponent } from './forms-tipo-aplicacao/forms-tipo-aplicacao.component';

@Component({
  selector: 'app-tipo-aplicacao',
  templateUrl: './tipo-aplicacao.component.html',
  styleUrls: ['./tipo-aplicacao.component.scss'],
  providers: [ForeignKeyService],
})
export class TipoAplicacaoComponent implements OnInit {

  @ViewChild("gridTiposAplicacao", { static: false })
  gridTiposAplicacao: SyncGridComponent;

  @ViewChild("FormsTipoAplicacao", { static: false })
  formsTipoAplicacao: FormsTipoAplicacaoComponent;

  tiposAplicacao: TipoAplicacao[] = [];
  auxTiposAplicacao: TipoAplicacao[];
  tipoAplicacao: TipoAplicacao;
  id: number;
  inserindo: boolean = false;
  carregando: boolean = false;

  tiposBicos: TipoBico[];

  form: any;
  public isSubmit: boolean;
  textoBusca: string = "";
  perfilLogado: number = 0;

  tipoAplicacaoColumns: ColumnModel[] = [];
  desabilitarAcoes: boolean = false
  removendo: boolean = false
  inativando: boolean = false
  duplicando: boolean = false
  gridHeight: string = '79vh';

  pageSettings?: PageSettingsModel = {
    pageSizes: [10, 20, 30, 40, 50, 100],
    pageSize: 20,
    pageCount: 4,
  };

  // tradução
  FEITO: string = "Feito!";
  ERRO: string = "Erro!";
  DELETAR: string = 'Deletar';
  SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA: string = 'Se deletar, esta ação não poderá ser desfeita!';
  CANCELAR: string = 'Cancelar';
  SIM: string = 'Sim';
  TIPO_DE_APLICACAO_DELETADA: string = 'Tipo de Aplicação deletada!';

  constructor(private tiposAplicacaoService: TipoAplicacaoService,
    private tipoBicoService: TipoBicoService,
    private route: ActivatedRoute, private router: Router,
    private utils: UtilsService,
    private translate: TranslateService,
    private storageService: StorageService,
    private toasty: CustomToastyService,
    private location: Location) {
  }

  ngOnInit() {
    this.perfilLogado = this.storageService.getUsuario().Perfil;
    this.tipoAplicacao = new TipoAplicacao();

    this.tipoBicoService.getTiposBicos().subscribe(ret => {
      this.tiposBicos = ret;
    });

    this.listarTiposAplicacao();
    this.configurarGrid();
  }

  ajustarTamanhoGrid(): void {
    const navbar = document.querySelector('app-nav-bar.navbar.pcoded-header') as HTMLElement
    const groupdroparea = document.querySelector('div.e-groupdroparea.e-lib.e-droppable.e-draggable') as HTMLElement
    const toolbar = document.querySelector('div.custom-toolbar.justify-content-between') as HTMLElement
    const title = document.querySelector('app-tipo-aplicacao h5.titulo') as HTMLElement
    const pager = document.querySelector('div.e-gridpager.e-control.e-pager.e-lib') as HTMLElement
    const altura = window.innerHeight - navbar.offsetHeight - groupdroparea.offsetHeight - toolbar.offsetHeight - title.offsetHeight - pager.offsetHeight - 70
    this.gridHeight = `${altura}px`
  }

  configurarGrid(): void {
    if (window.innerHeight <= 1000) this.pageSettings.pageSize = 20;
    else this.pageSettings.pageSize = 40

    this.tipoAplicacaoColumns = [
      { type: "checkbox", width: 50, showInColumnChooser: false },
      {
        field: "Descricao",
        headerText: "Descrição",
        allowSorting: true,
      },
      {
        field: "DataAlteracao",
        headerText: "Ult. Mod.",
        type: "date",
        format: "dd/MM/yyyy HH:mm",
        allowSorting: true,
      },
      {
        field: "UsuarioAlteracaoDesc",
        headerText: "Resp. Mod.",
        allowSorting: true,
      },
      {
        field: "descAtivo",
        headerText: "Status",
        allowSorting: true,
        disableHtmlEncode: false,
        type: 'boolean',
        valueAccessor: (_field: string, _data: any): any => {
          return this.badgeStatusUsuario(_data.Ativo);
        }
      } as ColumnModel,
    ]
    setTimeout(() => {
      this.ajustarTamanhoGrid();
    }, 1000);
  }

  doubleClick(event): void {
    this.editar(event)
  }

  badgeStatusUsuario(ativo: boolean): string {
    return ativo ? '<span class="badge badge-light-success custom-badge-grid">Ativo</span>' : '<span class="badge badge-light-danger custom-badge-grid">Inativo</span>'
  }

  listarTiposAplicacao() {
    this.ERRO = this.translate.instant("ERRO");
    this.carregando = true;
    this.tiposAplicacaoService.listarTodos()
      .pipe(
        finalize(() => {
          this.carregando = false;
        })
      )
      .subscribe(
        (res: TipoAplicacao[]) => {
          this.tiposAplicacao = res.map(u => Object.assign(new TipoAplicacao(), u));
          if (!this.inserindo)
            this.auxTiposAplicacao = res;
          if (this.textoBusca != '')
            this.filtrarTiposAplicacao();
        },
        err => {
          this.utils.getErro(err);
        })
  }

  novo(): void {
    if (!this.utils.verificarPermissaoUsuario('incluirTipoAplicacao'))
      return;

    this.formsTipoAplicacao.abrirModal();
  }

  editar(tipoAplicacao: TipoAplicacao): void {
    let tipo;
    if (!tipoAplicacao) {
      var tiposAplicacao = this.gridTiposAplicacao.getSelectedRecords();
      if (!this.ValidarSelectApenasUm()) return;

      tipo = { ...tiposAplicacao[0] };
    }
    else
      tipo = { ...tipoAplicacao }
    this.formsTipoAplicacao.abrirModal(tipo);
  }

  confirmaDuplicar(): void {
    var tiposAplicacao = this.gridTiposAplicacao.getSelectedRecords();
    if (!this.ValidarSelectUmOuMais()) return
    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: "Os tipos de aplicação selecionados serão duplicados!",
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Duplicar tipos de aplicação",
    }).then((response) => {
      if (!response.dismiss) {
        this.duplicar(tiposAplicacao);
      }
    });
  }

  duplicar(tiposAplicacao: TipoAplicacao[]): void {
    this.duplicando = true
    this.tiposAplicacaoService.duplicar(tiposAplicacao.map(p => p.Id))
      .subscribe(() => {
        this.utils.handleSuccess("Tipos de aplicação duplicados com sucesso")
        this.listarTiposAplicacao();
        this.duplicando = false
      },
        (err) => {
          this.utils.getErro(err)
          this.duplicando = false
        }
      )
  }

  ValidarSelectApenasUm(): boolean {
    var tiposAplicacao = this.gridTiposAplicacao.getSelectedRecords();
    if (tiposAplicacao.length == 0) {
      this.utils.handleWarning("Selecione um item para continuar");
      return false;
    }
    if (tiposAplicacao.length > 1) {
      this.utils.handleWarning("Selecione apenas um item para continuar");
      return false;
    }
    return true;
  }

  ValidarSelectUmOuMais(): boolean {
    var tiposAplicacao = this.gridTiposAplicacao.getSelectedRecords();
    if (tiposAplicacao.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return false;
    }

    return true;
  }

  confirmaInativar(): void {
    if (!this.ValidarSelectUmOuMais) return
    var tiposAplicacao = this.gridTiposAplicacao.getSelectedRecords();
    if (tiposAplicacao.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return;
    }

    const todasInativas = tiposAplicacao.every(v => v.Ativo === false);
    const algumaInativa = tiposAplicacao.some(v => v.Ativo === false);

    if (todasInativas) {
      this.utils.handleWarning("Todos os tipos de aplicação selecionados já estão inativos");
      return;
    }

    let texto = "Os tipos de aplicação selecionados serão inativados!";
    if (algumaInativa) {
      texto += '<br> Alguns tipos de aplicação já estão inativos e serão ignorados.';
    }

    Swal.fire({
      title: "Você tem certeza desta ação?",
      html: texto,
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Inativar tipos de aplicação",
    }).then((response) => {
      if (!response.dismiss) {
        this.inativar(tiposAplicacao);
      }
    });
  }

  inativar(tiposAplicacao: TipoAplicacao[]): void {
    this.inativando = true
    this.tiposAplicacaoService.inativar(tiposAplicacao.map(p => p.Id))
      .subscribe((res) => {
        if (res && typeof res === 'object' && Object.keys(res).length > 0) {
          const erros: string[] = [];
          Object.keys(res).forEach(id => {
            const item = tiposAplicacao.find(v => v.Id.toString() === id);
            const nomeItem = item ? item.Descricao : `ID ${id}`;
            erros.push(`<b>${nomeItem}</b>: ${res[id]}`);
          });

          Swal.fire({
            title: 'Erro ao Inativar Tipos de Aplicação',
            html: `Os seguintes tipos de aplicação não puderam ser inativados:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        } else if (tiposAplicacao.filter(v => v.Ativo === false).length > 0) {
          const erros: string[] = [];
          tiposAplicacao.filter(v => v.Ativo === false).forEach(item => {
            const nomeItem = item ? item.Descricao : `ID ${item.Id}`;
            erros.push(`<b>${nomeItem}</b>: Já está inativo.`);
          });
          Swal.fire({
            title: 'Erro ao Inativar tipos de aplicação',
            html: `os seguintes tipos de aplicação não puderam ser inativados:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        }
        else {
          this.utils.handleSuccess("Tipos de aplicação inativados com sucesso");
        }
        this.listarTiposAplicacao();
        this.inativando = false
      },
        (err) => {
          this.utils.getErro(err)
          this.inativando = false
        }
      )
  }

  finalizarSaveTipoAplicacao(): void {
    this.listarTiposAplicacao();
  }

  confirmRemover() {
    if (!this.utils.verificarPermissaoUsuario('ExcluirTipoAplicacao'))
      return;

    this.ERRO = this.translate.instant("ERRO");
    this.FEITO = this.translate.instant("FEITO");
    this.SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA = this.translate.instant("SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA");
    this.CANCELAR = this.translate.instant("CANCELAR");
    this.SIM = this.translate.instant("SIM");
    this.TIPO_DE_APLICACAO_DELETADA = this.translate.instant("TIPO_DE_APLICACAO_DELETADA");

    var tiposAplicacao = this.gridTiposAplicacao.getSelectedRecords();
    if (tiposAplicacao.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return;
    }
    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: "Os Tipos de Aplicação selecionados serão excluídos, esta ação não poderá ser desfeita!",
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: this.CANCELAR,
      confirmButtonText: this.SIM,
    }).then((willDelete) => {
      if (!willDelete.dismiss)
        this.removerTiposAplicacao(tiposAplicacao)
    });
  }

  removerTiposAplicacao(tiposAplicacao: TipoAplicacao[]) {
    this.removendo = true;
    this.tiposAplicacaoService.deleteTiposAplicacao(tiposAplicacao.map(p => p.Id)).subscribe(
      res => {
        console.debug('res: ', res)

        // Verificar se há erros no retorno (Dictionary<int, string>)
        if (res && typeof res === 'object' && Object.keys(res).length > 0) {
          // Há erros - exibir quais tipos de aplicação falharam
          const erros: string[] = [];
          Object.keys(res).forEach(id => {
            const tipoAplicacao = tiposAplicacao.find(v => v.Id.toString() === id);
            const nomeTipoAplicacao = tipoAplicacao ? tipoAplicacao.Descricao : `ID ${id}`;
            erros.push(`<b>${nomeTipoAplicacao}</b>: ${res[id]}`);
          });

          Swal.fire({
            title: 'Erro ao excluir tipos de aplicação',
            html: `Os seguintes tipos de aplicação não puderam ser excluídos:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        } else {
          // Sucesso - todos os tipos de aplicação foram excluídos
          this.utils.handleSuccess("Tipos de aplicação excluídos com sucesso");
        }

        this.listarTiposAplicacao();
        this.removendo = false;
      },
      err => {
        this.utils.getErro(err);
        this.removendo = false;
      });
  }

  filtrarTiposAplicacao() {
    this.tiposAplicacao = this.auxTiposAplicacao.filter(x =>
      x.Descricao.toUpperCase().includes(this.textoBusca.toUpperCase()) ||
      x.Id.toString().includes(this.textoBusca.toUpperCase())
    );
  }

  cancelar() {
    this.router.navigate(['/cadastros/tipo-aplicacao']);
  }

}
